import { o_util } from "@gr-common/async/namespaces";
const attributeParser = o_util.attributeParser ?? {};
const parseParameters = attributeParser.parseParameters;
const parseAttributeName = attributeParser.parseAttributeName;
const mergeParameterValues = attributeParser.mergeParameterValues;
export {
  attributeParser,
  mergeParameterValues,
  parseAttributeName,
  parseParameters
};
